var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.500026C7.0147 0.497409 6.03867 0.690214 5.12837 1.06728C4.21808 1.44435 3.39159 1.9982 2.69675 2.69678C1.28 4.11353 0.5 5.99753 0.5 8.00003C0.5 10.0025 1.28 11.8865 2.69675 13.3033C4.1135 14.72 5.9975 15.5 8 15.5C10.0025 15.5 11.8865 14.72 13.3032 13.3033C14.72 11.8865 15.5 10.0025 15.5 8.00003C15.5 5.99753 14.72 4.11353 13.3032 2.69678C12.6084 1.9982 11.7819 1.44435 10.8716 1.06728C9.96133 0.690214 8.9853 0.497409 8 0.500026ZM12.2428 12.2428C11.1095 13.376 9.60275 14 8 14C6.39725 14 4.8905 13.376 3.75725 12.2428C2.624 11.1095 2 9.60278 2 8.00003C2 6.39728 2.624 4.89053 3.75725 3.75728C4.69753 2.8135 5.92755 2.21289 7.25 2.05178V8.00003C7.25 8.19894 7.32902 8.3897 7.46967 8.53036C7.61032 8.67101 7.80109 8.75003 8 8.75003H13.9482C13.7871 10.0725 13.1865 11.3025 12.2428 12.2428ZM8.75 7.25003V2.04653C10.0728 2.21009 11.3026 2.81244 12.2428 3.75728C13.1881 4.69705 13.7906 5.92702 13.9535 7.25003H8.75Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.ba274685d09af624c3536c0f24c72330.svg";
export { ForwardRef as ReactComponent };